// extracted by mini-css-extract-plugin
export default {"container":"register-error-message_container__0Qn7K"};